export default "__VITE_ASSET__CH8Nk9fL__"